import { legacy_createStore as createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import {
  MODIFY_SCENARIO_PROPERTY,
  SET_SCENARIO,
  MODIFY_SCENARIO_MASS_PROPERTY,
  DELETE_MASS,
} from "./types";
import { LoadedScenarioType } from "../types/galaxy-scenario";
import { ScenarioActionTypes } from "../types/actions";

export const scenarioReducer = (
  state = <LoadedScenarioType>{},
  action: ScenarioActionTypes,
): LoadedScenarioType => {
  switch (action.type) {
    case SET_SCENARIO:
      return action.payload;

    case MODIFY_SCENARIO_PROPERTY:
      if ("collisions" in state) {
        return {
          ...state,
          [action.payload.key]: action.payload.value,
        };
      }

      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case MODIFY_SCENARIO_MASS_PROPERTY:
      if ("collisions" in state) {
        return {
          ...state,
          masses: state.masses.map((mass) => {
            if (mass.name === action.payload.name) {
              return { ...mass, [action.payload.key]: action.payload.value };
            }

            return mass;
          }),
        };
      }

      return {
        ...state,
        masses: state.masses.map((mass) => {
          if (mass.name === action.payload.name) {
            return { ...mass, [action.payload.key]: action.payload.value };
          }

          return mass;
        }),
      };

    case DELETE_MASS:
      if ("collisions" in state) {
        return {
          ...state,
          masses: state.masses.filter((mass) => action.payload !== mass.name),
        };
      }

      return {
        ...state,
        masses: state.masses.filter((mass) => action.payload !== mass.name),
      };

    default:
      return state;
  }
};

const store = createStore(scenarioReducer, applyMiddleware(thunk));

export default store;

export type ScenarioStateType = ReturnType<typeof store.getState>;
